import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AutoRefreshToogle } from "_components/buttons";
import { getIcons } from "_helpers";
import { eventsActions, vehicleActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";
import { TextField } from "@mui/material";

export { SettingsBus };

function SettingsBus() {

    const { busVin } = useParams();

    const dispatch = useDispatch();

    const autoRefresh = useSelector(state => state.vehicles.selectedVehicleDetails.autoRefresh);
    const [intervalId, setIntervalId] = useState(null);

    const today = moment();    
    const minStartDate = moment().subtract(30, "days");
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);

    /* Gestion de l'autorefresh */
    const handleToogleAutoRefresh = (value) => {
        dispatch(vehicleActions.toggleAutoRefresh(value));
    }  

    useEffect(() => {
        // Nettoie l'intervalle à chaque fois que le composant est démonté
        return () => {
            if (intervalId) {
                dispatch(vehicleActions.toggleAutoRefresh(false))
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [intervalId]);

    useEffect(() => {
        if (autoRefresh) {
            const id = setInterval(() => {
                dispatch(eventsActions.getLastEventsByVin(busVin));
                dispatch(vehicleActions.getVehicleWarnings(busVin));
                dispatch(vehicleActions.getVehicleLastPositions(busVin));
            }, 120000); // 120 secondes
            setIntervalId(id);
        } else {
            // Si autoRefresh est désactivé, nettoie l'intervalle
            if (intervalId) {
                dispatch(vehicleActions.toggleAutoRefresh(false))
                clearInterval(intervalId);
                setIntervalId(null);
            }
        }
        
        // Nettoyage sur le changement de busVin ou autoRefresh
        return () => {
            if (intervalId) {
                dispatch(vehicleActions.toggleAutoRefresh(false))
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [autoRefresh, busVin, dispatch]); 

    /**
     * Gestion du changement de la date de début 
     * La date maximale ne peut pas dépasser la date du jour 
     * et ne peut pas etre inférieur à 30 jour avant la date du jour
     * @param {*} date 
     */
    const handleStartDateChange = (date) => {
        if (!date) return;

        setStartDate(date);

        // Ajuste endDate si besoin
        if (endDate.isBefore(date) || endDate.isAfter(today) || endDate.diff(date, "days") > 30) {
            setEndDate(moment.min(moment(date).add(1, "days"), today));
        }
    };

    /**
     * Gestion du changement de la date de fin 
     * la date de fin ne dépasse pas aujourd'hui 
     * @param {*} date 
     */
    const handleEndDateChange = (date) => {
        if (!date) return;

        setEndDate(date);
    };


    /**
     * Changement des données après avoir sélectionné des dates
     */
    const handleChangeDates = () => {
        let queryParams = `min_date=${startDate.format('YYYY-MM-DD')}&max_date=${endDate.format('YYYY-MM-DD')}&vin=${busVin}`;

        dispatch(eventsActions.getFiltered(queryParams));
    }


    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="fr">
            <div className='settings-content overflow-auto'>         
                {/* RAFRAICHISSEMENT */}
                <div className="settings-title">
                    <span>RAFRAICHISSEMENT</span>
                </div>
                <div className="settings-info">Si activé les données sont rafraichies <br/>automatiquement toutes les 2 minutes</div>
                <div className="settings-selection">
                    <AutoRefreshToogle action={handleToogleAutoRefresh}/>
                </div>  
                {/* DATES */}
                <div className="settings-title">
                    <span>DATES</span>
                </div>
                <div className="settings-info">
                    Sélectionnez un interval de temps <br/>(30 derniers jours maximum)
                </div> 
                <div className="settings-selection flex"> 
                    <div className='w-[50%] mr-2'>                           
                        <DatePicker
                            label="Date de début"
                            value={startDate}
                            onChange={handleStartDateChange} 
                            minDate={minStartDate}                                                         
                            maxDate={today}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    size="small"
                                />
                            )}                                                    
                            className="form-control"  
                        />                                
                    </div>
                    <div className='w-[50%]'> 
                        <DatePicker
                            label="Date de fin"
                            value={endDate}
                            onChange={handleEndDateChange}
                            minDate={startDate}
                            maxDate={today}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                            className="form-control" 
                        />                                              
                    </div>                                  
                </div> 
                <div className="settings-selection ">
                    <button className="btn btn-custom btn-custom-primary float-right" onClick={handleChangeDates}>
                        <img src={getIcons('checkOutlined')} alt='add icon' className='btn-custom-icon'/>
                        APPLIQUER
                    </button>
                </div>
            </div>
        </LocalizationProvider>
    )
}
